import { render, staticRenderFns } from "./AgendaMensagens.vue?vue&type=template&id=45003165"
import script from "./AgendaMensagens.vue?vue&type=script&lang=js"
export * from "./AgendaMensagens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports